import React, { useEffect } from 'react';
import useGAEventsTracker from '../../utils/useGAEventsTrackers';

// components
import Title from '../../components/Title';
import Button from '../../components/Button';

// assets
import BankLogo from '../../assets/img/BankLogo.png';
import { Img, ImgDiv, WrapperDiv } from './errorStyled';

function StatusError({status}) {
  const GAEventsTracker = useGAEventsTracker(`Operation ${status} error`);
  useEffect(() => {
    GAEventsTracker(`Intento ingresar a una operación: "${status}"`);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

    const handleClose = () => {
        window.opener = null;
        window.open('', '_self');
        window.close();
    };
    const textError = {
      success:'¡Hola! Tu operación ya fue realizada correctamente',
      cancel:'Lo siento, esta operación fue cancelada'
    }
    return (
        <WrapperDiv>
            <Title grid="title">{textError[status]}</Title>
            <ImgDiv>
                <Img src={BankLogo} />
            </ImgDiv>
            <Button filled grid="buttons" onClick={handleClose}>
                Cerrar
            </Button>
        </WrapperDiv>
    );
}

export default StatusError;